import Modal from "components/Modal";
import ShoppingCartContent from "components/Modal/ShoppingCart/ShoppingCartContent";
import { useModalStore, Modal as ModalKey } from "stores/modal/useModalStore";

export const ShoppingCartModal = ({ isAdding, description }) => {
  const current = useModalStore((s) => s.current);
  const close = useModalStore((s) => s.close);
  const isOpen = current === ModalKey.ShoppingCart;

  return (
    <Modal
      showHeader
      modalIsOpen={isOpen}
      closeModal={close}
      style={{ width: '100%', padding: "40px", display: "flex", flexDirection: "column", alignItems: "center" }}
      className={`w-[340px] sm:!w-[497.768px] flex flex-col items-center justify-center h-auto`}
      title={isAdding ? "Added!" : "Already Added!"}
    >
      {{
        content: (
          <ShoppingCartContent
            description={
              description
                ? description
                : "The saddle is already added to your shopping cart."
            }
          />
        ),
      }}
    </Modal>
  );
};

export default ShoppingCartModal;